import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import {
  LISTINGS_PER_PAGE,
  useSearchResultsQuery,
} from './useSearchResultsQuery';

export function useSearchResultsPagination() {
  const params = useSearchParams();
  const { data } = useSearchResultsQuery();

  const currentPage = Number(params.get('page')) || 1;
  const totalResults = data?.result.total ?? 0;
  const pageCount = Math.max(1, Math.ceil(totalResults / LISTINGS_PER_PAGE));

  return {
    currentPage,
    pageCount,
  };
}
